// import {
//   LogoutOutlined,
//   LoginOutlined,
//   UserAddOutlined,
// } from "@ant-design/icons";
import "./index.css";

const footerList = [
  {
    key: "our offerings",
    label: "Our Offerings",
    path: "/our-offerings",
  },
  {
    key: "quick links",
    label: "Quick Links",
    path: "/quick-links",
  },
  {
    key: "popular destination",
    label: "Popular Destination",
    path: "/popular-destination",
  },
  {
    key: "international destination",
    label: "International Destination",
    path: "/international-destination",
  },
  // {
  //   key: "popular airline",
  //   label: "Popular Airline",
  // },
  {
    key: "connect with us",
    label: "connect with us",
    path: "/contact-us",
  },
  // {
  //   key: "offers",
  //   label: "Offers",
  // },
  // {
  //   key: "emt insights",
  //   label: "Emt Insights",
  // },
  // {
  //   key: "media",
  //   label: "Media",
  // },
  // {
  //   key: "investers relation",
  //   label: "Investers Relation",
  // },
  {
    key: "current openings",
    label: "Current Openings",
    path: "/careers",
  },
];

const travelModeLinks = [
  {
    key: "faq",
    label: "FAQ",
    path: "/faq",
  },
  {
    key: "privacyPolicy",
    label: "Privacy Policy",
    path: "/privacy-policy",
  },
  {
    key: "termsConditions",
    label: "Terms and Conditions",
    path: "/terms-conditions",
  },
  // {
  //   key: "emt pro",
  //   label: "EMT PRO",
  // },
  {
    key: "blog",
    label: "Blog",
    path: "/blog",
  },
  // {
  //   key: "hotels",
  //   label: "Hotels",
  //   path: '/hotels'
  // },
  {
    key: "cabs",
    label: "Cabs",
    path: "/cab-details",
  },
  // {
  //   key: "airports",
  //   label: "Airports",
  // },
  {
    key: "activities",
    label: "Activities",
    path: "/activities",
  },
  // {
  //   key: "flight check-in",
  //   label: "Flight Check-in",
  // },
  // {
  //   key: "trains",
  //   label: "Trains",
  // },
  // {
  //   key: "charters",
  //   label: "Charters",
  // },
  // {
  //   key: "travel guides",
  //   label: "Travel Guides",
  // },
  // {
  //   key: "travel updates",
  //   label: "Travel Updates",
  // },
  // {
  //   key: "holidays",
  //   label: "Holidays",
  // },
  // {
  //   key: "flight status",
  //   label: "Flight Status",
  // },
  // {
  //   key: "check pnr status",
  //   label: "Check PNR Status",
  // },
  {
    key: "corporate travel",
    label: "Corporate Travel",
    path: "/corporate-travel",
  },
];

export { footerList, travelModeLinks };
